import { styled } from "@mui/material/styles";
import RefreshIcon from "@mui/icons-material/Refresh";
import Button from "designSystem/components/button/Button";
import { blue } from "designSystem/styles/color";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import React, { FunctionComponent } from "react";

const PREFIX = "CommentOutdatedBanner";

const classes = {
	root: `${PREFIX}root`,
};

const StyledFlexRowCenter = styled(FlexRowCenter)((
	{
		theme,
	},
) => ({
	[`&.${classes.root}`]: {
		backgroundColor: blue[50],
		height: 30,
		justifyContent: "center",
	},
}));

interface CommentOutdatedBannerProps {
	onClick: () => void;
}

export const CommentOutdatedBanner: FunctionComponent<CommentOutdatedBannerProps> = (props) => {
	const { onClick } = props;

	return (
		<StyledFlexRowCenter className={classes.root}>
			<Button
				design="link"
				onClick={onClick}
				res="CommentsStale"
				startIcon={<RefreshIcon />}
			/>
		</StyledFlexRowCenter>
	);
};

export default CommentOutdatedBanner;